import styled from 'styled-components'
import { TitleWrapper } from 'components/Title/styles'
import measures from 'globals/measures'

export const HeaderWrapper = styled.div`
  margin-bottom: 22px;
  display: flex;

  & > ${TitleWrapper} {
    flex: 1;
  }

  @media(max-width: 800px) {
    margin-right: 19px;
  }
  
  @media(max-width: ${measures.mobileThreshold}px) {
    margin-bottom: 9px;
    margin-right: 0px;
  }
`
